// Styles
import { headerHeight } from '../../scripts/helpers';
import './template-collection.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  context.querySelectorAll('[grid-settings-wrapper] .svg-grid-size')
    .forEach(svgGridSize => {
      svgGridSize.addEventListener('click', () => {
        const gridSettingsWrapper = document.querySelector('[grid-settings-wrapper]');
        const gridColClass = gridSettingsWrapper.classList.item(0);
        gridSettingsWrapper.classList.remove(gridColClass);
        gridSettingsWrapper.classList.add(`grid-${svgGridSize.dataset.svgCol}-col`);
      });
    });

  const filters = templateCollectionSection.querySelector('.collection-main__filters');
  if (filters) {
    const filtersForm = templateCollectionSection.querySelector('form#FacetFiltersForm');
    const stickyBar = templateCollectionSection.querySelector('.collection-main__filter-breadcrumbs-bar');
    const openers = templateCollectionSection.querySelectorAll('.collection-main-filters__opener');
    const drawer = templateCollectionSection.querySelector('.collection-main-filters__drawer');
    const close = templateCollectionSection.querySelector('.collection-main-filters-drawer__close-icon');
    const backdrop = templateCollectionSection.querySelector('.collection-main-filters__drawer-wrapper');

    if (stickyBar && openers.length > 0 && drawer) {
      drawer.style.height = `calc(100% - ${headerHeight()}px)`;
      drawer.style.top = `${headerHeight()}px`;
      stickyBar.style.top = `${headerHeight()}px`;

      ['resize', 'orientationchange'].forEach(evt => {
        window.addEventListener(evt, () => {
          drawer.style.height = `calc(100% - ${headerHeight()}px)`;
          drawer.style.top = `${headerHeight()}px`;
          stickyBar.style.top = `${headerHeight()}px`;
        });
      });

      const openFilters = () => {
        filters.classList.add('open');
        document.querySelector('html').style.overflowY = 'hidden';
      };

      const closeFilters = () => {
        filters.classList.remove('open');
        document.querySelector('html').style.overflowY = '';
      };

      openers.forEach(opener => {
        if (opener.classList.contains('collection-main-filters__opener--mobile')) {
          opener.style.top = `${headerHeight()}px`;

          ['resize', 'orientationchange'].forEach(evt => {
            window.addEventListener(evt, () => {
              opener.style.top = `${headerHeight()}px`;
            });
          });
        }

        opener.addEventListener('click', () => {
          openFilters();
        });
      });

      close.addEventListener('click', () => {
        closeFilters();
      });

      backdrop.addEventListener('click', (e) => {
        if (e.target.classList.contains('collection-main-filters__drawer-wrapper')) {
          closeFilters();
        }
      });

      stickyBar.querySelectorAll('[data-for]').forEach(activeFilter => {
        const filtersForm = templateCollectionSection.querySelector('#FacetFiltersForm');

        if (filtersForm) {
          const submit = filtersForm.querySelector('[type="submit"]');
          const input = filtersForm.querySelector(`#${activeFilter.dataset.for}`);
          if (submit && input) {
            activeFilter.addEventListener('click', () => {
              input.checked = false;
              submit.click();
            });
          }
        }
      });
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
